import { render, staticRenderFns } from "./BasePageSubtitle.vue?vue&type=template&id=3248b3ac&"
import script from "./BasePageSubtitle.vue?vue&type=script&lang=js&"
export * from "./BasePageSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports